import React from 'react';
const FeedbackManagement = () => {
  return (
    <div className="p-6">
      <h1 className="font-serif font-bold text-3xl text-primary mb-6">Feedback Management</h1>
      <div className="bg-card p-8 rounded-xl shadow-card">
        <p className="text-muted-foreground">Manage feedback</p>
      </div>
    </div>
  );
};
export default FeedbackManagement;